import { useEffect, useState } from 'react';
import { getColor, htmlParserFunc } from '@/helpers/utils';
import Lightbox from 'react-18-image-lightbox';
import 'react-18-image-lightbox/style.css';
import { useAppContext } from '@/Main';
// برای نمایش Html در جدول
type HtmlParserProps = {
  html?: string | null;
};

const HtmlParser = ({ html }: HtmlParserProps) => {
  const [srcImage, setSrcImage] = useState<string | null>(null);

  const handleImageClick = (event: Event) => {
    event.preventDefault();
    const image = event.target as HTMLImageElement | null;
    setSrcImage(image?.getAttribute('src') ?? null);
  };

  const addClickListenersToImages = () => {
    const images = document.querySelectorAll('#parsedHtml img');
    images.forEach(img => {
      img.addEventListener('click', handleImageClick);
    });
  };

  useEffect(() => {
    addClickListenersToImages();
    return () => {
      const images = document.querySelectorAll('#parsedHtml img');
      images.forEach(img => {
        img.removeEventListener('click', handleImageClick);
      });
    };
  }, [html]);
  const {
    config: { isDark }
  } = useAppContext();
  return (
    <>
      {srcImage && (
        <Lightbox
          mainSrc={srcImage}
          onCloseRequest={() => setSrcImage('')}
          reactModalStyle={{ overlay: { zIndex: 999999 } }}
          onImageLoad={() => {
            window.dispatchEvent(new Event('resize'));
          }}
        />
      )}
      <div id="parsedHtml">
        {html && (
          <div dangerouslySetInnerHTML={{ __html: htmlParserFunc(html) }}></div>
        )}
        <style>{`
        #parsedHtml {
  font-size: 1rem;
  line-height: 2.2;
}

      #parsedHtml strong { color: ${getColor('danger')}; }
#parsedHtml figure figcaption { text-align: center; margin-top: 10px; }
#parsedHtml video { width: 100%; }
#parsedHtml h1, 
#parsedHtml h2,
#parsedHtml h3,
#parsedHtml h4,
#parsedHtml h5,
#parsedHtml h6 {
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

#parsedHtml h1 { font-size: 2.3rem; }
#parsedHtml h2 { font-size: 2.0rem; }
#parsedHtml h3 { font-size: 1.428rem; }
#parsedHtml h4 { font-size: 0.9rem; }

#parsedHtml p,
#parsedHtml ul,
#parsedHtml ol,
#parsedHtml pre,
#parsedHtml table {
  margin-bottom: 1.25rem;
  line-height: 2;
}

#parsedHtml pre {
  color: rgb(248, 248, 242);
  background-color: #232e3c !important;
  font-size: 0.875rem;
  border: 1px solid var(--falcon-border-color);
  border-radius: 0.25rem;
  padding: 10px;
  direction: ltr !important;
  overflow: auto;
}

#parsedHtml table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
  box-shadow: 0 0 0 1px ${getColor('gray-300')};
}

#parsedHtml th,
#parsedHtml td {
  border: 1px solid ${getColor('gray-300')};
  padding: 0.75rem;
  text-align: center;
  vertical-align: middle;
}

#parsedHtml th {
  background-color: ${getColor('gray-200')};
  font-weight: 600;
}

#parsedHtml tr:nth-child(even) {
  background-color: ${isDark ? getColor('gray-200') : getColor('gray-100')};
}

#parsedHtml table caption {
  caption-side: bottom;
  text-align: center;
  font-size: 0.85rem;
  color: ${getColor('gray-600')};
  padding: 0.5rem;
}

#parsedHtml ul,
#parsedHtml ol {
  padding-left: 1.5rem;
}
        `}</style>
      </div>
    </>
  );
};

export default HtmlParser;
